import { MappedResult } from '../mapped/index.mjs';
import { Optional } from './optional.mjs';
// prettier-ignore
function FromProperties(P, F) {
    return globalThis.Object.getOwnPropertyNames(P).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Optional(P[K2], F) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, F) {
    return FromProperties(R.properties, F);
}
// prettier-ignore
export function OptionalFromMappedResult(R, F) {
    const P = FromMappedResult(R, F);
    return MappedResult(P);
}
